import { render } from "./Trustpilot.vue?vue&type=template&id=cb2e3762"
import script from "./Trustpilot.vue?vue&type=script&lang=js"
export * from "./Trustpilot.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__